export default __webpack_public_path__ + "static/media/RINGS - black.4504f257.png";